import React from 'react';
import moment from 'moment-timezone';

import { MainContent, PageHeading } from '../components/Shell/Content';
import DataTable from '../components/DataTable';

import useAsync from '../hooks/useAsync';

import { getAllTasks } from '../api/admin';

const Tasks = () => {
	const { value: tasksByOrganization } = useAsync(getAllTasks);

	const utcCheckerTimer = moment().utc().hour(9).minute(0).seconds(0);

	return (
		<MainContent maxWidth="w-full">
			<PageHeading divider={false}>Task Checker</PageHeading>

			<div className="mb-6">
				Next check:{' '}
				{`${
					moment().isAfter(utcCheckerTimer)
						? utcCheckerTimer?.add(1, 'day').fromNow()
						: utcCheckerTimer.fromNow()
				} (UTC ${utcCheckerTimer.format('h:mmA')} EST ${utcCheckerTimer
					.tz('America/New_York')
					.format('h:mmA')})`}
			</div>

			{tasksByOrganization?.map((organizationTask) => {
				return (
					<>
						{`${organizationTask?.organization?.name}`}{' '}
						<span className="text-gray-400 text-xs font-normal font-base ml-3">
							{`Send at ${moment
								.unix(organizationTask?.sendAt)
								.format('h:mmA')}`}
						</span>
						{Object.keys(organizationTask?.emailBreakdown)?.map((userEmail) => {
							return (
								<DataTable
									title={
										<>
											<div className="text-xs text-gray-600">{userEmail}</div>
										</>
									}
									columns={[
										{
											header: 'Label',
											accessorKey: 'dateLabel',
											cell: (info) => info?.getValue() || '',
										},
										{
											header: 'Service',
											accessorKey: 'service.name',
											cell: (info) => {
												return info?.getValue() || '';
											},
										},
										{
											header: 'Category',
											accessorKey: 'categoryName',
											cell: (info) => {
												return info?.getValue() || '';
											},
										},
										{
											header: 'Assets',
											accessorKey: 'assets',
											cell: (info) => {
												const original = info?.getValue() || [];

												return (
													<ul>
														{original?.map((asset) => (
															<li>{`${asset?.name} ${asset?.serialNumber}`}</li>
														))}
													</ul>
												);
											},
										},
									]}
									data={{ rows: organizationTask?.emailBreakdown[userEmail] }} //[...task?.upcoming, ...task?.overdue] }}
									hasCheckboxes={false}
									useExport={false}
									usePagination={false}
									useSearch={false}
								/>
							);
						})}
					</>
				);
			})}

			<div></div>
		</MainContent>
	);
};

export default Tasks;
